function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
/**
 * UI helpers for editing unlock_transaction_base outputs.
 * Does not attach fee funding; that lives on unlock_transaction_final.
 */

var Slip = require('./../../../../lib/saito/slip')["default"];
var _require = require('saito-js/lib/slip'),
  SlipType = _require.SlipType;
var _require2 = require('./unlock_tx_fee'),
  assertUnlockEditable = _require2.assertUnlockEditable,
  invalidateUnlockSignatures = _require2.invalidateUnlockSignatures,
  isUnlockEditable = _require2.isUnlockEditable;
function escapeHtml(text) {
  return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatNolanAmount(app, amount) {
  try {
    var _app$wallet;
    var nolan = BigInt(amount || 0);
    if (typeof (app === null || app === void 0 || (_app$wallet = app.wallet) === null || _app$wallet === void 0 ? void 0 : _app$wallet.convertNolanToSaito) === 'function') {
      return app.wallet.convertNolanToSaito(nolan);
    }
    return String(nolan);
  } catch (_err) {
    return String(amount || '0');
  }
}
function isNftSlip(slip) {
  var _slip$type;
  var type = Number((_slip$type = slip === null || slip === void 0 ? void 0 : slip.type) !== null && _slip$type !== void 0 ? _slip$type : slip === null || slip === void 0 ? void 0 : slip.slip_type);
  return type === SlipType.Bound || type === 9;
}
function unlockBaseOutputs(mod) {
  var _mod$unlock_transacti;
  return Array.isArray(mod === null || mod === void 0 || (_mod$unlock_transacti = mod.unlock_transaction_base) === null || _mod$unlock_transacti === void 0 ? void 0 : _mod$unlock_transacti.to) ? mod.unlock_transaction_base.to : [];
}

/** User-created outputs on the editable base (fee change is never shown here). */
function unlockUserOutputs(mod) {
  return unlockBaseOutputs(mod);
}
function assignedSaitoNolan(mod) {
  var sum = BigInt(0);
  var _iterator = _createForOfIteratorHelper(unlockUserOutputs(mod)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var slip = _step.value;
      if (isNftSlip(slip)) {
        continue;
      }
      try {
        sum += BigInt(slip.amount || 0);
      } catch (_err) {
        /* ignore */
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return sum;
}
function lockedSaitoNolan(mod) {
  try {
    var _mod$unlockContext;
    return BigInt((mod === null || mod === void 0 || (_mod$unlockContext = mod.unlockContext) === null || _mod$unlockContext === void 0 || (_mod$unlockContext = _mod$unlockContext.lockedSlip) === null || _mod$unlockContext === void 0 ? void 0 : _mod$unlockContext.amount) || 0);
  } catch (_err) {
    return BigInt(0);
  }
}
function remainingSaitoNolan(mod) {
  var rem = lockedSaitoNolan(mod) - assignedSaitoNolan(mod);
  return rem > BigInt(0) ? rem : BigInt(0);
}
function hasNftOutput(mod) {
  return unlockUserOutputs(mod).some(isNftSlip);
}
function nftUnits(mod) {
  var ctx = mod === null || mod === void 0 ? void 0 : mod.unlockContext;
  if (!ctx) {
    return BigInt(0);
  }
  if (ctx.nftAmount != null && ctx.nftAmount !== '') {
    try {
      return BigInt(ctx.nftAmount);
    } catch (_err) {
      /* fall through */
    }
  }
  try {
    var _ctx$lockedNftSlips;
    return BigInt(((_ctx$lockedNftSlips = ctx.lockedNftSlips) === null || _ctx$lockedNftSlips === void 0 || (_ctx$lockedNftSlips = _ctx$lockedNftSlips[1]) === null || _ctx$lockedNftSlips === void 0 ? void 0 : _ctx$lockedNftSlips.amount) || 1);
  } catch (_err) {
    return BigInt(1);
  }
}
function remainingNftUnits(mod) {
  return hasNftOutput(mod) ? BigInt(0) : nftUnits(mod);
}
function refreshUnlockCandidate(mod) {
  var mainUi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  // Editable base changed — discard any stale funded clone (should not exist while editable).
  if (mod && isUnlockEditable(mod)) {
    mod.unlock_transaction_final = null;
  }
  if (typeof (mod === null || mod === void 0 ? void 0 : mod.cloneUnlockCandidate) === 'function') {
    mod.cloneUnlockCandidate();
  }
  // Outputs are part of the signed transaction — clear CHECKSIG / CHECKMULTISIG witnesses.
  invalidateUnlockSignatures(mod, mainUi);
}
function addSaitoOutput(app, mod, _ref) {
  var _app$crypto, _app$crypto$isPublicK;
  var recipient = _ref.recipient,
    amountSaito = _ref.amountSaito,
    amountNolan = _ref.amountNolan;
  var mainUi = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  assertUnlockEditable(mod);
  var base = mod === null || mod === void 0 ? void 0 : mod.unlock_transaction_base;
  if (!base) {
    throw new Error('Unlock transaction is not ready.');
  }
  if (!recipient) {
    throw new Error('Recipient address is required.');
  }
  if (!(app !== null && app !== void 0 && (_app$crypto = app.crypto) !== null && _app$crypto !== void 0 && (_app$crypto$isPublicK = _app$crypto.isPublicKey) !== null && _app$crypto$isPublicK !== void 0 && _app$crypto$isPublicK.call(_app$crypto, recipient))) {
    throw new Error('Enter a valid recipient address.');
  }
  var nolan;
  if (amountNolan != null && amountNolan !== '') {
    try {
      nolan = BigInt(amountNolan);
    } catch (_err) {
      throw new Error('Enter an amount greater than zero.');
    }
  } else {
    nolan = app.wallet.convertSaitoToNolan(String(amountSaito || '').trim());
  }
  if (nolan <= BigInt(0)) {
    throw new Error('Enter an amount greater than zero.');
  }
  var available = remainingSaitoNolan(mod);
  if (nolan > available) {
    throw new Error('Amount exceeds the remaining balance.');
  }
  var output = new Slip();
  output.publicKey = recipient;
  output.amount = nolan;
  output.type = SlipType.Normal;
  base.addToSlip(output);
  refreshUnlockCandidate(mod, mainUi);
  return output;
}
function addNftOutput(app, mod, _ref2) {
  var _app$crypto2, _app$crypto2$isPublic;
  var recipient = _ref2.recipient;
  var mainUi = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  assertUnlockEditable(mod);
  var base = mod === null || mod === void 0 ? void 0 : mod.unlock_transaction_base;
  var ctx = mod === null || mod === void 0 ? void 0 : mod.unlockContext;
  if (!base || !ctx) {
    throw new Error('Unlock transaction is not ready.');
  }
  if (!recipient) {
    throw new Error('Recipient address is required.');
  }
  if (!(app !== null && app !== void 0 && (_app$crypto2 = app.crypto) !== null && _app$crypto2 !== void 0 && (_app$crypto2$isPublic = _app$crypto2.isPublicKey) !== null && _app$crypto2$isPublic !== void 0 && _app$crypto2$isPublic.call(_app$crypto2, recipient))) {
    throw new Error('Enter a valid recipient address.');
  }
  if (hasNftOutput(mod)) {
    throw new Error('This NFT already has an output.');
  }
  var output = new Slip();
  output.publicKey = recipient;
  output.amount = nftUnits(mod);
  output.type = SlipType.Bound;
  base.addToSlip(output);
  refreshUnlockCandidate(mod, mainUi);
  return output;
}
function removeOutputAt(mod, index) {
  var mainUi = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  assertUnlockEditable(mod);
  var base = mod === null || mod === void 0 ? void 0 : mod.unlock_transaction_base;
  var outputs = unlockBaseOutputs(mod);
  if (!base || index < 0 || index >= outputs.length) {
    return false;
  }
  outputs.splice(index, 1);
  refreshUnlockCandidate(mod, mainUi);
  return true;
}
function parsePositiveSaitoAmount(raw) {
  var text = String(raw || '').trim();
  if (!text) {
    return null;
  }
  var num = Number(text);
  if (!Number.isFinite(num) || num <= 0) {
    return null;
  }
  return text;
}
module.exports = {
  escapeHtml: escapeHtml,
  formatNolanAmount: formatNolanAmount,
  isNftSlip: isNftSlip,
  unlockBaseOutputs: unlockBaseOutputs,
  unlockUserOutputs: unlockUserOutputs,
  remainingSaitoNolan: remainingSaitoNolan,
  remainingNftUnits: remainingNftUnits,
  hasNftOutput: hasNftOutput,
  addSaitoOutput: addSaitoOutput,
  addNftOutput: addNftOutput,
  removeOutputAt: removeOutputAt,
  parsePositiveSaitoAmount: parsePositiveSaitoAmount
};